import httpReq from '@/server/http';
import { systemType } from '@/utils/utils';

const httpRequest = {
  // **************************分享页 start****************
  // 发送验证码
  sendVerifyCode: function(params) {
    var url = '/api/common/v1/auth/send-verify-code';

    return httpReq(url, 'post', params);
  },
  // 获取文档内容
  getDocumentContent: function(params) {
    var url = '/api/common/v1/document/detail';

    return httpReq(url, 'get', params);
  },
  // 获取分享或打开app微信参数配置
  getShareWXSDK: function (params) {
    var url = '/api/common/v1/wx/config';

    return httpReq(url, 'get', params);
  },
  // 获取 视频详情
  getVideoDetail: function (params) {
    var url = '/api/common/v1/video/detail';

    return httpReq(url, 'get', params);
  },
  // 获取 课程详情 / 课程套餐详情
  getCourseDetail: function (params) {
    var url = '/api/common/v1/course/detail';

    return httpReq(url, 'get', params);
  },
  // 获取 课程小节
  getCourseSectionList: function (params) {
    var url = '/api/common/v1/course/section';

    return httpReq(url, 'get', params);
  },
  // 获取 相关的课程列表
  getRelatedCommendCourseList(params) {
    var url = "/api/common/v1/course/rel-recommend";

    return httpReq(url, 'get', params);
  },
  // 获取 相课程的评论列表
  getCourseCommentList(params) {
    var url = "/api/common/v1/course/comment";

    return httpReq(url, 'get', params);
  },
  // 获取 子评论列表
  getSubCommentList(params) {
    var url = "/api/common/v1/comment";

    return httpReq(url, 'get', params);
  },

  // 获取 直播详情 / 直播课程套餐详情
  getLivingDetail: function (params) {
    var url = '/api/common/v1/live/detail';

    return httpReq(url, 'get', params);
  },
  // 获取 相关推荐的直播列表
  getRelCommendLivingList: function (params) {
    var url = '/api/common/v1/live/rel-recommend';

    return httpReq(url, 'get', params);
  },
  // 获取 最新资讯详情
  getInformationDetail: function (params) {
    var url = '/api/common/v1/information/detail';

    return httpReq(url, 'get', params);
  },
  // 获取 最新资讯详情里的评论列表
  getInformationCommentList: function (params) {
    var url = '/api/common/v1/information/comment';

    return httpReq(url, 'get', params);
  },
  // 获取 健康测测的结果详情
  getHealthyTestResultInfo: function (params) {
    var url = '/api/common/v1/test-activity/answer-record/detail';

    return httpReq(url, 'get', params);
  },
  // 获取 动态详情
  getHealthyCircleDetail: function (params) {
    var url = '/api/common/v1/dynamic/detail';

    return httpReq(url, 'get', params);
  },
  // 获取 健康圈下的评论列表
  getHealthyCircleCommentList(params) {
    var url = "/api/common/v1/dynamic/comment";

    return httpReq(url, 'get', params);
  },
  // 获取 赠送的订单详情
  getCourseOrderDetail: function (params) { // getOrderDetail
    // var url = '/api/common/v1/order/detail';
    // var url = '/api/common/v1/auth/user/order/detail';
    var url = '/api/common/v1/course/order/detail';

    return httpReq(url, 'get', params);
  },
  // 获取赠送的直播订单详情
  getLiveOrderDetail: function (params) {
    var url = '/api/common/v1/live/order/detail';

    return httpReq(url, 'get', params);
  },
  // 领取课程时 - 发送验证码     account
  sendVerifyCodeToPhone: function (params) {
    var url = '/api/common/v1/order/receive-present/send-verify-code';

    return httpReq(url, 'post', params);
  },
  // 领取赠送的课程
  receiveSendCourse: function (params) {
    var url = '/api/common/v1/order/receive-present';

    return httpReq(url, 'post', params);
  },
  // 获取banner信息详情
  getBannerDetail: function(params) {
    var url = '/api/common/v1/banner/detail';

    return httpReq(url, 'get', params);
  },
  // 获取症状、疾病、药品详情
  getCSMDetailInfo(params){
    var url = '/api/common/v1/base/detail';

    return httpReq(url, 'get', params);
  },
  // 领取赠送的课程 新
  receivePresentCourse: function (params) {
    var url = '/api/common/v1/order/course-receive-present';

    return httpReq(url, 'post', params);
  },
  // 领取赠送的直播课 新
  receivePresentLiveCourse: function (params) {
    var url = '/api/common/v1/order/live-receive-present';

    return httpReq(url, 'post', params);
  },
  // 获取活动专题的详情
  getActivityProjectDetail(params){
    var url = '/api/common/v1/active-pages/detail';

    return httpReq(url, 'get', params);
  },
  // **************************分享页 end****************
  // 小鹅通课程详情
  getXiaoECourseDetail: function(data) {
    var url = '/api/common/v1/xiaoe-courses/detail';
    let params = {...data || {},...{zeqiao_platform: systemType(),zeqiao_client: 'web',}}

    return httpReq(url, 'get', params);
  },
  getWxOpenId: function(data) {
    var url = '/api/common/v1/wx/openid';
    let params = {...data || {},...{zeqiao_platform: systemType(),zeqiao_client: 'web',}}

    return httpReq(url, 'get', params);
  },
  getPayOrderInfo: function(data) {
    var url = '/api/common/v1/xiaoe-courses/order';
    let params = {...data || {},...{zeqiao_platform: systemType(),zeqiao_client: 'web',}}

    return httpReq(url, 'post', params);
  },
  getPayParameters: function(data) {
    var url = '/api/common/v1/pay';
    let params = {...data || {},...{zeqiao_platform: systemType(),zeqiao_client: 'web',}}
    // alert(JSON.stringify(params));
    return httpReq(url, 'post', params);
  },
  getPayResult: function(data) {
    var url = '/api/common/v1/pay/result';
    let params = {...data || {},...{zeqiao_platform: systemType(),zeqiao_client: 'web',}}

    return httpReq(url, 'get', params);
  },

}

export default httpRequest



// WEBPACK FOOTER //
// ./src/server/http-api.js